module.exports = __webpack_public_path__ + "img/こんな方-01.5827ce05.png";